import { Paper, styled } from '@mui/material';
// A deliberate reach into the visual-refresh directory: when the flag retires and that directory is
// deleted, this import breaks loudly and forces the branch below to be resolved.
import { LIGHT_2 } from 'common/theme/refresh/tokens';
import { omitForwardedProps } from 'common/utils';

type WrapperProps = {
  bordered?: boolean;
  isLoading?: boolean;
};

const LOGIN_BOX_SHADOW = '0px 4px 8px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)';

export const Wrapper = styled(Paper, {
  shouldForwardProp: omitForwardedProps<WrapperProps>('isLoading', 'bordered'),
})<WrapperProps>(({ theme: { palette, shape, spacing, breakpoints, visualRefresh }, bordered, isLoading }) => {
  // DS 2.0 has no elevation: the card is separated by its outline alone (Figma node 18187:17351).
  // The shadow is a literal here rather than a theme value, so the theme swap cannot reach it and
  // this surface has to branch for itself.
  const boxShadow = visualRefresh ? 'none' : LOGIN_BOX_SHADOW;
  const border = `1px solid ${visualRefresh ? LIGHT_2 : palette.grey[200]}`;

  return {
    padding: spacing(4),
    width: 428,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3),
    flexShrink: 0,
    overflow: 'hidden',
    background: palette.background.paper,
    border,
    boxShadow,
    ...(bordered && {
      borderRadius: shape.borderRadius * 2,
      background: palette.background.paper,
      border,
      boxShadow,
    }),
    ...(isLoading && {
      height: 400,

      '& iframe': {
        visibility: 'hidden',
      },
    }),
    [breakpoints.down('sm')]: {
      border: 'none',
      boxShadow: 'none',
      width: '100%',
      padding: spacing(3, 0),
    },
  };
});

export const StyledIframe = styled('iframe')({
  border: 'none',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  '&&::-webkit-scrollbar': {
    display: 'none',
  },
});
